<template>
    <div>
        <b-row>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="Nombre"
                    v-model="exhibitor.name"
                    required
                    @input="$v.exhibitor.name.$touch()"
                    :error="$v.exhibitor.name.$error"
                ></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="Documento"
                    v-model="exhibitor.document"
                    required
                    @input="$v.exhibitor.document.$touch()"
                    :error="$v.exhibitor.document.$error"
                ></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="E-mail"
                    v-model="exhibitor.email"
                    required
                    @input="$v.exhibitor.email.$touch()"
                    :error="$v.exhibitor.email.$error"
                ></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="Teléfono"
                    v-model="exhibitor.phone"
                ></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="País"
                    v-model="exhibitor.country"
                    required
                    @input="$v.exhibitor.country.$touch()"
                    :error="$v.exhibitor.country.$error"
                ></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="Ciudad"
                    v-model="exhibitor.city"
                    required
                    @input="$v.exhibitor.city.$touch()"
                    :error="$v.exhibitor.city.$error"
                ></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="Profesión"
                    v-model="exhibitor.profession"
                ></app-form-input>
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-input
                    label="Habilidades"
                    v-model="exhibitor.skills"
                ></app-form-input>
            </b-col>
            <b-col cols="12">
                <app-form-text-area
                    label="Perfil"
                    v-model="exhibitor.profile"
                ></app-form-text-area>
            </b-col>
            <b-col cols="12">
                <label for="">Foto</label>
                <b-form-file accept="image/*" v-model="photo" capture="camera"></b-form-file>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
export default {
    props: {
        event: {
            type: Object,
            required: true,
        }
    },
    data: () => ({
        exhibitor: {
            name: '',
            document: '',
            email: '',
            phone: '',
            skills: '',
            profession: '',
            profile: '',
            country: '',
            city: '',
        },
        photo: null,
    }),
    validations: {
        exhibitor: {
            name: {required},
            document: {required},
            email: {required, email},
            country: {required},
            city: {required},
        }
    },
    methods: {
        async save() {
            this.$v.$touch()
            if(this.$v.$invalid) return toastr.error('Debe diligenciar adecuadamente todos los datos')

            try {
                this.$emit('busy', true)
                let photo = null;
                if(!!this.photo){
                    photo = await this.fileToBase64(this.photo)
                }

                const payload = {...this.exhibitor, photo, eventId: this.event.id}

                const {data: exhibitor} = await this.$repo.post('event-exhibitors', payload)

                this.$emit('success', exhibitor)

            } catch (error) {
                toastr.error('Ocurrió un error, por favor intente de nuevo más tarde')
            } finally {
                this.$emit('busy', false)
            }

        }
    }
}
</script>

<style>

</style>
